import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Navimumbaitofivejyotilinga() {



    const cardData = {

keyword: "Navi Mumbai to 5 Jyotirlinga Darshan Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Navi Mumbai to 5 Jyotirlinga Darshan Cab services for pilgrimage tours, family trips, group travel, and spiritual journeys across Maharashtra. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Navi Mumbai, and comfortable long-distance travel, we ensure a safe, convenient, and spiritually fulfilling 5 Jyotirlinga Darshan Yatra experience for all devotees.",

topPlaces: [
    {
        title: "Trimbakeshwar Jyotirlinga - Nashik",
        description:
            "Trimbakeshwar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva, located near Nashik and famous for its spiritual importance and ancient temple architecture."
    },
    {
        title: "Bhimashankar Jyotirlinga - Pune District",
        description:
            "Bhimashankar Jyotirlinga is situated amidst the Sahyadri hills and is known for its serene surroundings, dense forests, and deep religious significance."
    },
    {
        title: "Grishneshwar Jyotirlinga - Ellora",
        description:
            "Grishneshwar Jyotirlinga near Ellora Caves is the last of the twelve Jyotirlingas and attracts devotees with its beautiful stone-carved temple architecture."
    },
    {
        title: "Aundha Nagnath Jyotirlinga - Hingoli",
        description:
            "Aundha Nagnath is considered one of the oldest Jyotirlinga temples in India and is a major pilgrimage destination in Maharashtra."
    },
    {
        title: "Parli Vaijnath Jyotirlinga - Beed",
        description:
            "Parli Vaijnath Jyotirlinga is a revered Shiva temple known for its spiritual atmosphere and is an important stop in the Maharashtra Jyotirlinga circuit."
    },
    {
        title: "Ellora Caves",
        description:
            "Located near Grishneshwar Temple, Ellora Caves is a UNESCO World Heritage Site featuring remarkable rock-cut temples and ancient Indian art."
    },
    {
        title: "Shirdi Sai Baba Temple",
        description:
            "Many pilgrims combine Shirdi Sai Baba Darshan with the 5 Jyotirlinga tour for a more complete spiritual journey across Maharashtra."
    },
    {
        title: "Shani Shingnapur",
        description:
            "Shani Shingnapur is a famous pilgrimage destination dedicated to Lord Shani and is often included in Jyotirlinga travel itineraries."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort near Aurangabad is a historic hill fort known for its impressive defense architecture and panoramic views."
    },
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves is a UNESCO World Heritage Site famous for ancient Buddhist paintings, sculptures, and historical significance."
    }
],



services: [
{
name: "Navi Mumbai to 5 Jyotirlinga Darshan Cab",
description: "Navi Mumbai to 5 Jyotirlinga Darshan Cab service by 1Touch Cabs offers a complete pilgrimage travel solution for devotees visiting the sacred Jyotirlingas of Maharashtra including Trimbakeshwar, Bhimashankar, Grishneshwar, Aundha Nagnath, and Parli Vaijnath. We provide Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller vehicles with professional chauffeurs experienced in long-distance temple routes. Our service includes comfortable seating, air-conditioned vehicles, flexible itineraries, luggage assistance, and safe highway travel. Whether you are planning a family pilgrimage, group yatra, spiritual retreat, or senior citizen tour, we ensure a smooth and memorable journey with 24x7 support, transparent pricing, and reliable service."
},
{
name: "5 Jyotirlinga Darshan Cab from Navi Mumbai",
description: "5 Jyotirlinga Darshan Cab from Navi Mumbai provides convenient transportation for devotees seeking a comfortable pilgrimage across Maharashtra's sacred Shiva temples. 1Touch Cabs offers experienced drivers, clean vehicles, flexible schedules, and reliable service. We focus on passenger comfort, timely temple visits, safe highway travel, and a peaceful spiritual experience throughout the complete Jyotirlinga circuit."
},
{
name: "Navi Mumbai 5 Jyotirlinga Yatra Cab",
description: "Navi Mumbai 5 Jyotirlinga Yatra Cab service is designed for pilgrims who wish to undertake a well-organized religious tour covering all major Jyotirlinga temples in Maharashtra. 1Touch Cabs provides spacious vehicles, professional chauffeurs, and customized travel plans. Our service ensures comfortable travel, smooth route management, and stress-free pilgrimage arrangements for families and groups."
},
{
name: "5 Jyotirlinga Tour Package Navi Mumbai by Cab",
description: "5 Jyotirlinga Tour Package Navi Mumbai by Cab offers a complete travel package with dedicated vehicles and experienced drivers for temple visits. 1Touch Cabs ensures clean air-conditioned vehicles, convenient pickup and drop facilities, flexible itineraries, and comfortable long-distance travel. This package is ideal for families, devotional groups, and spiritual travelers."
},
{
name: "Navi Mumbai to Jyotirlinga Darshan Taxi",
description: "Navi Mumbai to Jyotirlinga Darshan Taxi service provides reliable and affordable transportation for devotees visiting the holy Jyotirlinga temples. 1Touch Cabs offers professional chauffeurs, comfortable vehicles, and safe travel arrangements. Our service focuses on convenience, punctuality, and a smooth pilgrimage experience from start to finish."
},
{
name: "5 Jyotirlinga Darshan Yatra Cab",
description: "5 Jyotirlinga Darshan Yatra Cab service offers a dedicated pilgrimage vehicle for devotees planning a complete Jyotirlinga circuit. 1Touch Cabs provides well-maintained vehicles, courteous drivers, and flexible travel schedules. We ensure safe road journeys, comfortable seating, and dependable support throughout the religious tour."
},
{
name: "Jyotirlinga Darshan Cab Service Navi Mumbai",
description: "Jyotirlinga Darshan Cab Service Navi Mumbai delivers professional pilgrimage transportation for individuals, families, and groups. 1Touch Cabs offers clean vehicles, experienced chauffeurs, and customized travel options. We ensure comfortable travel, timely darshan opportunities, and reliable service for every passenger."
},
{
name: "Maharashtra 5 Jyotirlinga Darshan Cab",
description: "Maharashtra 5 Jyotirlinga Darshan Cab service covers the most revered Jyotirlinga temples within Maharashtra through a comfortable and well-planned road journey. 1Touch Cabs provides safe transportation, professional drivers, and spacious vehicles. Our focus is on making spiritual travel convenient, comfortable, and memorable."
},
{
name: "Jyotirlinga Tour Cab from Navi Mumbai",
description: "Jyotirlinga Tour Cab from Navi Mumbai offers complete transportation support for devotees planning a religious tour across multiple Jyotirlinga destinations. 1Touch Cabs provides reliable vehicles, experienced chauffeurs, and flexible tour schedules. We ensure smooth travel, passenger safety, and excellent service quality throughout the journey."
},
{
name: "Lord Shiva Jyotirlinga Darshan Cab",
description: "Lord Shiva Jyotirlinga Darshan Cab service is designed for devotees seeking a sacred pilgrimage experience with reliable transportation. 1Touch Cabs provides comfortable vehicles, courteous drivers, and well-planned travel routes. Our service ensures a peaceful and convenient journey to important Shiva temples."
},
{
name: "AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai",
description: "AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai offers fully air-conditioned vehicles for comfortable long-distance pilgrimage travel. 1Touch Cabs ensures clean interiors, professional chauffeurs, and smooth road journeys. Our service provides a relaxing travel experience for families, senior citizens, and groups."
},
{
name: "Round Trip Cab Navi Mumbai to Jyotirlinga",
description: "Round Trip Cab Navi Mumbai to Jyotirlinga service provides complete return transportation for devotees undertaking a multi-day temple tour. 1Touch Cabs offers flexible schedules, experienced drivers, and reliable support throughout the pilgrimage. We ensure safe travel and comfortable returns after darshan."
},
{
name: "Private Cab for 5 Jyotirlinga Darshan",
description: "Private Cab for 5 Jyotirlinga Darshan service provides exclusive transportation for families and groups seeking privacy and flexibility during their pilgrimage. 1Touch Cabs offers dedicated vehicles, professional chauffeurs, and customized itineraries. Our service ensures personalized travel and complete convenience."
},
{
name: "Taxi Booking for Jyotirlinga Darshan Navi Mumbai",
description: "Taxi Booking for Jyotirlinga Darshan Navi Mumbai allows devotees to reserve reliable transportation quickly and conveniently. 1Touch Cabs offers instant booking assistance, multiple vehicle options, transparent pricing, and dependable chauffeur services. We make pilgrimage planning simple and hassle-free."
},
{
name: "Best Cab Service for 5 Jyotirlinga Darshan",
description: "Best Cab Service for 5 Jyotirlinga Darshan provides premium pilgrimage transportation with a focus on comfort, safety, and reliability. 1Touch Cabs offers experienced drivers, well-maintained vehicles, and flexible travel packages. Our service is trusted by families, groups, and spiritual travelers across Maharashtra."
},
{
name: "Innova Crysta for 5 Jyotirlinga Darshan",
description: "Innova Crysta for 5 Jyotirlinga Darshan service offers premium comfort and spacious seating for long pilgrimage journeys. 1Touch Cabs provides luxury vehicles, professional chauffeurs, and smooth travel arrangements. This option is ideal for families and groups seeking a comfortable religious tour experience."
},
{
name: "Ertiga Cab for Jyotirlinga Tour",
description: "Ertiga Cab for Jyotirlinga Tour service offers economical and comfortable transportation for small families and groups. 1Touch Cabs provides clean vehicles, reliable drivers, and convenient travel arrangements. Our service ensures affordable pilgrimage travel without compromising comfort or safety."
},
{
name: "Tempo Traveller 5 Jyotirlinga Darshan",
description: "Tempo Traveller 5 Jyotirlinga Darshan service is perfect for large families, devotional groups, and organized pilgrimages. 1Touch Cabs offers spacious Tempo Travellers with comfortable seating, professional drivers, and ample luggage space. We ensure enjoyable group travel throughout the Jyotirlinga circuit."
},
{
name: "12 Seater Tempo Traveller Jyotirlinga",
description: "12 Seater Tempo Traveller Jyotirlinga service provides comfortable group transportation for medium-sized pilgrimage groups. 1Touch Cabs offers air-conditioned vehicles, experienced chauffeurs, and reliable travel arrangements. Our service ensures a smooth and enjoyable temple tour experience."
},
{
name: "17 Seater Tempo Traveller Jyotirlinga",
description: "17 Seater Tempo Traveller Jyotirlinga service is designed for larger pilgrimage groups requiring spacious and comfortable transportation. 1Touch Cabs provides well-maintained vehicles, professional drivers, and safe travel support. We ensure convenient group journeys with excellent comfort throughout the pilgrimage."
},
{
name: "Navi Mumbai to 5 Jyotirlinga Cab Fare",
description: "Navi Mumbai to 5 Jyotirlinga Cab Fare service provides transparent and competitive pricing for pilgrimage travel. 1Touch Cabs offers affordable fare options for Sedan, SUV, Innova, Innova Crysta, Ertiga, and Tempo Traveller vehicles. We ensure value for money with reliable service and no hidden charges."
},
{
name: "5 Jyotirlinga Darshan Cab Package Navi Mumbai",
description: "5 Jyotirlinga Darshan Cab Package Navi Mumbai combines transportation convenience with customized pilgrimage planning. 1Touch Cabs provides experienced chauffeurs, comfortable vehicles, flexible itineraries, and dependable customer support. Our package is ideal for spiritual journeys across Maharashtra."
},
{
name: "Affordable Jyotirlinga Cab from Navi Mumbai",
description: "Affordable Jyotirlinga Cab from Navi Mumbai service offers budget-friendly pilgrimage transportation without compromising comfort or safety. 1Touch Cabs provides economical travel packages, clean vehicles, and experienced drivers. We make religious travel accessible and convenient for all devotees."
},
{
name: "Book 5 Jyotirlinga Cab Online",
description: "Book 5 Jyotirlinga Cab Online service allows passengers to reserve pilgrimage transportation quickly through a simple booking process. 1Touch Cabs offers instant confirmation, flexible vehicle selection, transparent pricing, and professional customer support. We ensure hassle-free travel planning for every devotee."
},
{
name: "Cheapest Cab for Jyotirlinga Darshan",
description: "Cheapest Cab for Jyotirlinga Darshan service provides economical transportation solutions for devotees visiting the sacred Jyotirlinga temples. 1Touch Cabs offers affordable fares, reliable vehicles, experienced chauffeurs, and dependable service. We focus on delivering value, comfort, and convenience throughout the pilgrimage journey."
}
],

tableData: [
["Navi Mumbai to 5 Jyotirlinga Darshan Cab","5 Jyotirlinga Darshan Cab from Navi Mumbai"],
["Navi Mumbai 5 Jyotirlinga Yatra Cab","5 Jyotirlinga Tour Package Navi Mumbai by Cab"],
["Navi Mumbai to Jyotirlinga Darshan Taxi","5 Jyotirlinga Darshan Yatra Cab"],
["Jyotirlinga Darshan Cab Service Navi Mumbai","Maharashtra 5 Jyotirlinga Darshan Cab"],
["Jyotirlinga Tour Cab from Navi Mumbai","Lord Shiva Jyotirlinga Darshan Cab"],
["AC Cab for 5 Jyotirlinga Darshan from Navi Mumbai","Round Trip Cab Navi Mumbai to Jyotirlinga"],
["Private Cab for 5 Jyotirlinga Darshan","Taxi Booking for Jyotirlinga Darshan Navi Mumbai"],
["Best Cab Service for 5 Jyotirlinga Darshan","Innova Crysta for 5 Jyotirlinga Darshan"],
["Ertiga Cab for Jyotirlinga Tour","Tempo Traveller 5 Jyotirlinga Darshan"],
["12 Seater Tempo Traveller Jyotirlinga","17 Seater Tempo Traveller Jyotirlinga"],
["Navi Mumbai to 5 Jyotirlinga Cab Fare","5 Jyotirlinga Darshan Cab Package Navi Mumbai"],
["Affordable Jyotirlinga Cab from Navi Mumbai","Book 5 Jyotirlinga Cab Online"],
["Cheapest Cab for Jyotirlinga Darshan","Jyotirlinga Tour Cab from Navi Mumbai"]
],













whychoose: [
    {
        WhyChooseheading: "Reliable Navi Mumbai to 5 Jyotirlinga Darshan Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Navi Mumbai to 5 Jyotirlinga Darshan Cab services for devotees, families, senior citizens, pilgrimage groups, and spiritual travelers seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Complete 5 Jyotirlinga Pilgrimage Experience",
        WhyChoosedescription: "Our customized pilgrimage packages cover five sacred Jyotirlingas, offering devotees a convenient and spiritually fulfilling journey across important Shiva temples."
    },
    {
        WhyChooseheading: "Perfect for Religious and Spiritual Tours",
        WhyChoosedescription: "Whether you are planning a family pilgrimage, group darshan tour, temple yatra, or spiritual retreat, our cab services provide a seamless travel experience."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "Flexible Multi-Day Tour Packages",
        WhyChoosedescription: "We offer customized 5 Jyotirlinga packages with flexible durations, sightseeing options, accommodation stops, and personalized travel itineraries."
    },
    {
        WhyChooseheading: "Pickup Available Across Navi Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Vashi, Nerul, Belapur, Kharghar, Panvel, Airoli, Ghansoli, Koparkhairane, CBD Belapur, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Pilgrimage Routes",
        WhyChoosedescription: "Our professional chauffeurs are familiar with temple routes and pilgrimage destinations, ensuring safe, comfortable, and hassle-free travel."
    },
    {
        WhyChooseheading: "Ideal for Families, Senior Citizens, and Groups",
        WhyChoosedescription: "From individual devotees and families to large pilgrimage groups, we provide suitable vehicles for every religious travel requirement."
    }
]
};

const faqData = [
    {
        question: "Which Jyotirlingas are covered in the 5 Jyotirlinga Darshan Package?",
        answer: "The package typically covers Trimbakeshwar, Bhimashankar, Grishneshwar, Parli Vaijnath, and Aundha Nagnath or can be customized according to customer preferences."
    },
    {
        question: "Can I customize my 5 Jyotirlinga itinerary?",
        answer: "Yes, customers can customize temple destinations, travel duration, sightseeing stops, and accommodation requirements."
    },
    {
        question: "Which vehicle is suitable for 5 Jyotirlinga Darshan?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, Tempo Travellers, and Mini Buses are available based on passenger count and comfort requirements."
    },
    {
        question: "How many days are required for 5 Jyotirlinga Darshan?",
        answer: "The tour duration generally ranges from 3 to 6 days depending on the selected temples, travel schedule, and sightseeing preferences."
    },
    {
        question: "Can senior citizens travel comfortably on this pilgrimage?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for senior citizens, families, and long-distance religious travel."
    },
    {
        question: "Are Tempo Travellers available for religious groups?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for pilgrimage groups, family tours, and temple yatra packages."
    },
    {
        question: "Can pickup be arranged from any Navi Mumbai location?",
        answer: "Yes, pickup services are available from homes, hotels, offices, railway stations, and all major areas of Navi Mumbai."
    },
    {
        question: "Do you provide round-trip 5 Jyotirlinga packages?",
        answer: "Yes, complete round-trip pilgrimage packages with flexible itineraries are available."
    },
    {
        question: "Is advance booking recommended for 5 Jyotirlinga Darshan?",
        answer: "Yes, advance booking is recommended, especially during Shravan month, Mahashivratri, long weekends, and holiday seasons."
    },
    {
        question: "How can I book a Navi Mumbai to 5 Jyotirlinga Darshan Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Prakash Deshmukh",
        feedback:
            "Our 5 Jyotirlinga pilgrimage was organized perfectly. The vehicle was comfortable, the driver was knowledgeable about all temple routes, and the entire journey was spiritually enriching.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Meena Patil",
        feedback:
            "We traveled with our family for the 5 Jyotirlinga Darshan tour and had an excellent experience. The cab was clean, spacious, and the travel arrangements were managed professionally throughout the trip.",
        rating: 5
    }
];
























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to 5 Jyotirlinga Darshan Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/navi-mumbai-to-5-jyotirlinga-cab.jpg",
  "description": "Book Navi Mumbai to 5 Jyotirlinga Darshan cab service for a comfortable spiritual pilgrimage tour. Mumbai Airport Cabs offers safe, reliable, and AC taxi service for Jyotirlinga yatra with professional drivers and flexible round trip packages.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4860"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹19,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/navi-mumbai-to-5-jyotirlinga-darshan-cab"
  }
};



    return (
        <div>



<Helmet>
  <title>Navi Mumbai to 5 Jyotirlinga Darshan Cab | Yatra Taxi Service | +91 9545731161</title>

  <meta
    name="description"
    content="Book Navi Mumbai to 5 Jyotirlinga Darshan cab service for spiritual yatra. Safe AC taxi with professional drivers and flexible tour packages."
  />

  <meta
    name="keywords"
    content="Navi Mumbai to 5 Jyotirlinga Darshan Cab, 5 Jyotirlinga Darshan Cab from Navi Mumbai, Navi Mumbai 5 Jyotirlinga Yatra Cab, 5 Jyotirlinga Tour Package Navi Mumbai by Cab, Navi Mumbai to Jyotirlinga Darshan Taxi, 5 Jyotirlinga Darshan Yatra Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Navimumbaitofivejyotilinga;